import { Injectable, Pipe, PipeTransform } from '@angular/core';
@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'endereco',
  standalone: true,
})
export class EnderecoPipe implements PipeTransform {
  constructor() { }

  transform(value: any, hideComplemento: boolean = false): string {
    if (!value) return '--';
    if (value.paisNome && value.paisNome !== 'BRASIL') {
      return value.formatado;
    }

    const parts: string[] = [];

    if (value.logradouro && value.numero) parts.push(`${value.logradouro} ${value.numero}`);
    else if (value.logradouro) parts.push(value.logradouro);
    else if (value.numero) parts.push(value.numero);
    if (value.bairro) parts.push(value.bairro);

    const cidadeNome = value.cidadeNome || value.cidade?.nome;
    const estadoSigla = value.estadoSigla || value.estado;
    if (cidadeNome || estadoSigla) {
      parts.push([cidadeNome, estadoSigla].filter(Boolean).join(' - '));
    }

    if (value.cep) parts.push(value.cep);
    if (value.paisNome) parts.push(value.paisNome);
    if (value.complemento && !hideComplemento) parts.push(value.complemento);

    return parts.length ? parts.join(', ') : '--';
  }

}
